import React from "react";
import Reveal from "./Reveal";
import Counter from "./Counter";
import { Quote } from "lucide-react";

const STEEL_IMG =
  "https://images.unsplash.com/photo-1709617101980-20e8a609550f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxicnVzaGVkJTIwc3RlZWwlMjB0ZXh0dXJlfGVufDB8fHx8MTc3ODY1ODI1MHww&ixlib=rb-4.1.0&q=85";

const pillars = [
  { value: 50, suffix: "+", label: "Years of unbroken practice" },
  { value: 200, suffix: "+", label: "Projects delivered" },
  { value: 100, suffix: "%", label: "Licensed workforce" },
  { value: 0, suffix: "", label: "Compromise on workmanship", display: "Zero" },
];

export const Legacy = () => {
  return (
    <section id="legacy" data-testid="legacy-section" className="relative py-28 md:py-40 bg-bone-200 overflow-hidden">
      {/* Brushed steel parallax overlay */}
      <div className="absolute inset-0 opacity-[0.10] pointer-events-none mix-blend-multiply">
        <img src={STEEL_IMG} alt="" className="w-full h-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-bone-100/40 via-transparent to-bone-300/30 pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-10 items-center">
          <div className="col-span-12 lg:col-span-7">
            <Reveal>
              <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-gold-deep">
                / 05 — Legacy &amp; Trust
              </span>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-slate-900 leading-[1.02] tracking-tight text-balance">
                Trusted for over <span className="italic text-gold-deep">five decades</span> — by builders, by developers, by industry.
              </h2>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-5">
            <Reveal delay={200} className="relative blueprint-border bg-white/85 backdrop-blur-xl p-8 md:p-10">
              <Quote size={28} className="text-gold-deep/70" />
              <p className="mt-5 font-display text-2xl md:text-[28px] text-slate-900 leading-[1.3] italic">
                "Their plumbing teams have walked our sites for over thirty years.
                That continuity, that quiet competence — it is rarer than it should be."
              </p>
              <div className="mt-8 flex items-center gap-3">
                <div className="h-px w-8 bg-gold-deep" />
                <div>
                  <div className="font-mono text-[11px] uppercase tracking-[0.28em] text-slate-900">
                    Construction Partner
                  </div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-slate-500 mt-1">
                    Pune · Maharashtra
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        {/* Pillars */}
        <div className="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-px bg-slate-900/8 border border-slate-900/8">
          {pillars.map((p, i) => (
            <Reveal
              key={p.label}
              delay={i * 100}
              className="bg-white/80 backdrop-blur-sm p-8 md:p-10"
              data-testid={`legacy-pillar-${i}`}
            >
              <div className="font-display text-5xl md:text-6xl gold-gradient-text tracking-tight">
                {p.display ? p.display : <Counter to={p.value} suffix={p.suffix} />}
              </div>
              <div className="mt-4 text-sm text-slate-700 leading-relaxed max-w-[14rem]">
                {p.label}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Legacy;
